/**
 * ? 요청이 한 번 더 늘어나는데, 비용에 문제가 될까?
 *
 * @param url
 * @returns
 */
export async function preflightRequest(url: URL) {
  try {
    const response = await fetch(url.toString(), {
      method: 'head',
    });
    console.debug({ response });
    return response.ok;
  } catch (error) {
    console.error(error);
    return false;
  }
}
